module.exports = __webpack_public_path__ + "json/kfz24/manifest.json";